var React = require('react');

function LinkArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M44.8555 1.14355L50.7695 10.4834L44.8555 18.7705","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M50.5 10.5L2 11","strokeWidth":"2","strokeLinecap":"square","key":1})]);
}

LinkArrow.defaultProps = {"width":"52","height":"20","viewBox":"0 0 52 20"};

module.exports = LinkArrow;

LinkArrow.default = LinkArrow;
